import { StyledFullDetailsSectionItem } from "../dashboard-user-details-main-section.style"

const DashboardUserDetailsMainSectionItem = ({ item }) => {

    const { title, children } = item
    return (
        <StyledFullDetailsSectionItem>
            <h2 className="item-title">{title}</h2>
            <div className="info-details">
                {children.map((child, idx) => (
                    <div key={idx}>
                        <h3 className="item-sub-title">{child.childTitle}</h3>
                        <p className="item-sub-text">{child.childValue}</p>
                    </div>
                ))}
            </div>

        </StyledFullDetailsSectionItem>
    )
}

export default DashboardUserDetailsMainSectionItem